import script from "./UpdateProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateProduct.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateProduct.vue?vue&type=style&index=0&id=551006f2&lang=scss"

const __exports__ = script;

export default __exports__